// extracted by mini-css-extract-plugin
export var childrenContainer = "_bu-0";
export var virtualScrollArea = "_bu-1";